// extracted by mini-css-extract-plugin
export default {"title":"WrapperSectionHome-module--title--QPJ4p","link":"WrapperSectionHome-module--link--UCPGV","linkUnderline":"WrapperSectionHome-module--linkUnderline--R8ab-"};